import React from 'react';
import appStoreBadge from '../../../../assets/download-on-the-apple-store.svg';
import googlePlayBadge from '../../../../assets/get-it-on-google-play.svg';

export default function StoreButtons() {
  return (
    <div className="ra-store-buttons">
      <a
        href="https://apps.apple.com/us/app/room-alert/id6447250947"
        target="_blank"
        rel="noopener noreferrer"
        className="ra-store-btn"
      >
        <img
          src={appStoreBadge}
          alt="Download on the App Store"
          className="ra-store-btn-img"
        />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.avtramobile"
        target="_blank"
        rel="noopener noreferrer"
        className="ra-store-btn"
      >
        <img
          src={googlePlayBadge}
          alt="Get it on Google Play"
          className="ra-store-btn-img"
        />
      </a>
    </div>
  );
}
